import request from './request';

export const getCompoareInfo = (data: object) => request(`${import.meta.env.VITE_API_PREFIX}/pub/compare`, 'GET', data);
export const fetchCompareDetail = (data: object) => request(`${import.meta.env.VITE_API_PREFIX}/pub/compare/detail`, 'POST_JSON', data);
